import React from "react";

export default function SearchExpansionNotice({
  count,
  loading,
  dismissed,
  onDismiss,
  onOpenFilters,
}) {
  if (dismissed || loading) return null;
  const title = count === 0
    ? "Sin comparables con estos filtros"
    : `Encontramos ${count} resultado${count === 1 ? "" : "s"}`;
  return (
    <section className="search-expansion-notice" aria-label="Ajustar filtros" aria-live="polite">
      <button type="button" className="search-expansion-notice__close" aria-label="Cerrar aviso de filtros" onClick={onDismiss}>
        <i className="pi pi-times" aria-hidden="true" />
      </button>
      <strong><i className="pi pi-filter" aria-hidden="true" /> {title}</strong>
      <p>Ajustá los filtros a mano para sumar comparables. Conservá los que definan la búsqueda.</p>
      <div className="search-expansion-notice__actions">
        <button type="button" onClick={onOpenFilters}>Ajustar filtros</button>
        {count >= 2 && (
          <button type="button" onClick={onDismiss}>Mantener búsqueda</button>
        )}
      </div>
    </section>
  );
}
